// Moves the theme's Add to Cart block (buy_buttons) so it visually sits between
// "Purchase options" and "Delivery frequency" inside the Joy Subscription app's
// (Avada) widget. The theme only exposes that whole widget as a single opaque
// app block, so this can't be done via section block_order in templates/*.json
// -- Purchase options and Delivery frequency are two sub-elements Avada renders
// *inside* that one block, in markup we don't control.
//
// This is a DOM-reparenting hack, not a supported integration point. It relies
// on Avada's current class names (Avada-Subscription__Container,
// Avada-Subscription__RadioContainer, etc.) which can change on any app update
// with no notice -- if the button stops appearing in the right place, that's
// the first thing to check (inspect the live widget markup again).
//
// The MutationObserver is required, not optional: confirmed via testing
// (Playwright) that Avada actually removes the Delivery frequency <fieldset>
// from the DOM when the customer picks "One-time purchase" and re-adds a new
// one when they pick "Subscribe and save" again -- it doesn't just hide it.
// A one-time move on page load breaks on the first toggle; this re-runs
// positionBuyButtons() on every DOM change inside the widget so the button
// stays correctly placed as the fieldset comes and goes.
(function () {
  var BUY_BUTTONS_SELECTOR = '.main-product__block-buy_buttons';
  var SUBSCRIPTION_ROOT_SELECTOR = '.Avada-SubscriptionWidget-Block';
  var CONTAINER_SELECTOR = '.Avada-Subscription__Container';
  var DELIVERY_SELECTOR = 'fieldset.Avada-Subscription__RadioContainer';

  function positionBuyButtons() {
    var buyButtons = document.querySelector(BUY_BUTTONS_SELECTOR);
    var container = document.querySelector(CONTAINER_SELECTOR);
    if (!buyButtons || !container) return;

    var delivery = container.querySelector(DELIVERY_SELECTOR);

    if (delivery) {
      if (buyButtons.nextElementSibling !== delivery) {
        container.insertBefore(buyButtons, delivery);
      }
    } else if (buyButtons.parentElement !== container) {
      container.appendChild(buyButtons);
    }
  }

  function init() {
    var root = document.querySelector(SUBSCRIPTION_ROOT_SELECTOR);
    if (!root) return;

    positionBuyButtons();

    var observer = new MutationObserver(positionBuyButtons);
    observer.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
